// @ts-ignore
export const MANAGER_AND_SUBMANAGER_DELEGATION_ERROR_CODE = 'REMOVE DELEGATION';
